import React from 'react';
import { Link } from 'react-router';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import RaisedButton from 'material-ui/RaisedButton';
import { TableRow, TableRowColumn } from 'material-ui/Table';

import styles from 'styles';
import moment from 'moment';

function VesselListRow(props) {
    const { item } = props;
    const { modifiedFields } = item;

    let fields = [];
    if (modifiedFields) {
        fields = modifiedFields.map(i => i.updatedField);
    }

    const showModifiedFields = () => (
        <TableRowColumn style={styles.tableRowColumnModifed}>
            <p>
                {fields.includes('typeByConstruction') ? 'Type by construction' : null} <br />
                {fields.includes('geared') ? 'Geared' : null} <br />
                {fields.includes('deadWeight.sTpc') ? 'TPC' : null} <br />
                {fields.includes('grabbed') ? 'Grab fitted' : null} <br />
                {fields.includes('registerClass') ? 'Register class' : null}<br />
            </p>
        </TableRowColumn>
    );

    let gears = item.gearV2All ? item.gearV2All.join(', ') : null;
    if (!gears && item.geared) {
        gears = 'Geared';
    }

    return (
        <TableRow>
            <TableRowColumn style={styles.tableRowColumnSmallCSS}>
                {item.imoNumber}
            </TableRowColumn>
            <TableRowColumn style={styles.tableRowColumnSmallCSS}>
                {item.name}
            </TableRowColumn>
            <TableRowColumn style={styles.tableRowColumnSmallCSS}>
                {item.blt}
            </TableRowColumn>
            <TableRowColumn style={styles.tableRowColumnCSS}>
                {item.typeByPurpose}
            </TableRowColumn>
            <TableRowColumn style={styles.tableRowColumnCSS}>
                {item.registerClass && item.registerClass.name}
            </TableRowColumn>
            <TableRowColumn style={styles.tableRowColumnCSS}>
                {gears}
            </TableRowColumn>
            <TableRowColumn style={styles.tableRowColumnSmallCSS}>
                {item.capacity && item.capacity.grain}
            </TableRowColumn>
            <TableRowColumn style={styles.tableRowColumnSmallCSS}>
                {item.dw && item.dw.summer}
            </TableRowColumn>
            <TableRowColumn style={styles.tableRowColumnModifed}>
                { showModifiedFields() }
            </TableRowColumn>
            <TableRowColumn style={styles.tableRowColumnSmallCSS}>
                {item.rt && (
                    <div className='text-center'>{item.rt.countryName}<br />{moment(item.rt.enteredAt).format('DD-MM-YYYY')}</div>
                )}
            </TableRowColumn>
            <TableRowColumn style={styles.tableRowColumnSmallCSS}>
                <RaisedButton
                    label='Edit'
                    primary
                    containerElement={<Link to={`/vessels/${item._id}`} />}
                />
            </TableRowColumn>
        </TableRow>
    );
}

export default connect(
    (state, { item }) => ({
        item,
    }),
    dispatch => bindActionCreators(
        {
        },
        dispatch,
    ),
)(VesselListRow);



// WEBPACK FOOTER //
// ./app/components/Vessels/List/Row.jsx